<template>
  <div>
    <v-layout row wrap fill-height>
      <v-flex xs12 fill-height>
        <!-- Player -->
        <v-card
          flat
          class="media-stream-player"
          width="100%"
          :height="$vuetify.breakpoint.width < 600 ? '40vh' : playerHeight"
        ></v-card>
      </v-flex>
    </v-layout>
    <Analytics
      v-if="player"
      ref="analytics"
      :screener="meta"
      :currentTime="player.currentTime"
      :currentFilmIndex="null"
      :filmId="meta.selected_media_id"
    ></Analytics>
  </div>
</template>
<script>
import Artplayer from "artplayer";
import * as hlsStream from "@/hlsStreamingHandler";
import Analytics from "@/components/screener/Analytics";
import { EventBus } from "@/event-bus";
import { getAuthHash } from "@/api/_manager";

export default {
  name: "MediaStreamPlayer",
  props: {
    meta: {
      type: Object,
      default: null,
    },
    consumer: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      player: null,
      hlsInstance: null,
      hlsAvailableResolutions: [],
    };
  },
  components: {
    Analytics,
  },
  computed: {
    movieSourceUrl() {
      return this.meta.streaming_url;
    },
    isSeekingBlocked() {
      return this.meta.no_skip ? this.meta.no_skip :false;
    },
    isPauseBlocked() {
      return this.meta.no_pause ? this.meta.no_pause :false;
    },
    authHeaders() {
      return JSON.stringify(getAuthHash(this.meta.screener_id));
    },
    availableSubtitles() {
      // return this.meta.subtitles.map((subtitle) => ({
      //   name: subtitle.lang_subtitle,
      //   url: subtitle.src_subtitle,
      //   html: subtitle.lang_subtitle,
      // }));
      return [];
    },
    customIcons() {
      return {
        subtitle:
          '<i class="fa fa-cc" style="font-size: large;align-items: center;display: flex;float: left;justify-content: center;height: 36px;width: 36px;" ></i>',
        qualitySwitcher:
          '<i class="fa fa-cog" style="font-size: large;align-items: center;display: flex;float: left;justify-content: center;height: 36px;width: 36px;" ></i>',
      };
    },
    playerHeight() {
      // const isFullScreenWithEmbed = this.meta.isEmbedMode && this.meta.isFullScreenMode
      return this.meta.isFullScreenMode ? '98vh' :'60vh'
    }
  },
  mounted() {
    this.initialisePlayer();
  },

  methods: {
    async initialisePlayer() {
      /**
       * 1. Load all default configurations of player
       * 2. Configure all event listeners with its listeners
       * 3. Add watermark to player
       */
      await this.loadPlayer();
      this.addCustomControls();
      // this.addWaterMark(this.player);
      this.configureAllEventListeners(this.player);
    },

    /**
     *===========================================================================================
     *                               INITIALIZE PLAYER CONFIGS
     *===========================================================================================
     */
    /**
     * Initialize player with its configurations
     */
    loadPlayer() {
      let _this = this;
      return (this.player = new Artplayer({
        container: ".media-stream-player",
        autoMini: true,
        pip: true,
        autoplay: true,
        isLive: _this.isSeekingBlocked, // Use this flag to disable seeking
        hotkey: true, // Stop hotkeys if seeking is blocked for event
        url: _this.movieSourceUrl,
        fullscreen: true,
        whitelist: ["*"],
        customType: {
          m3u8: function (video, url) {
            _this.hlsInstance = hlsStream.initialize(
              video,
              url,
              _this.authHeaders
            );
          },
        },
      }));
    },

    /**
     * As we are using hls streamings with player because of this, player doesn't
     * support some default controls like, quality-switcher,etc. But player provide
     * option to add custom controls and these controls are very effective and specific
     * to its use case.
     *
     * THIS FUNCTION IS RESPONSIBLE FOR CONFIGURING ALL CUSTOM CONTROLS
     */
    addCustomControls() {
      this.addSubtitleControls(this.player);
      this.addCustomQualitySwitcher(this.player);
    },

    /**
     * This function is responsible to add company logo as
     * a watermark
     */
    addWaterMark(playerInstance) {
      playerInstance.layers.add({
        html: `<img style="width: 100px" src="${this.meta.company_logo}">`,
        style: {
          position: "absolute",
          top: "20px",
          right: "20px",
          opacity: ".9",
        },
      });
    },

    /**
     * Configure all event listners with its handeler
     */
    configureAllEventListeners(playerInstance) {
      let _this = this;
    //   playerInstance.on("ready", () => {
    //     _this.onReady(playerInstance);
    //   });
    //   playerInstance.on("video:ended", () => {
    //     _this.onVideoEnd(playerInstance);
    //   });
      playerInstance.on("video:timeupdate", () => {
        _this.handelTimeUpdate(playerInstance);
      });
      playerInstance.on("video:pause",() => {_this.pauseHandler(playerInstance) });
      /**
       * EVENT BUSES
       */
      EventBus.$on("hls:availableResolutions", (payload) => {
        // Available resolutions will be calculated on every new HLS URL (sort of computed)
        _this.hlsAvailableResolutions = payload;
        _this.addCustomQualitySwitcher(_this.player);
      });

      //Show Notifications on full screen
      EventBus.$on("showSupportNotification", (payload) => {
        if (playerInstance.fullscreen) {
          playerInstance.notice.show = payload.message;
        }
      });
    },

    /**
     *===========================================================================================
     *                               PLAYER EVENT HANDLERS
     *===========================================================================================
     */
    /**
     * Player Ready State handler
     */
    onReady(playerInstance) {
      // Ready state handler
    },

    /**
     * Video end event listners
     */
    async onVideoEnd(playerInstance) {
      // Video ended handler
    },

    /**
     * Timeupdate Listner
     */
    handelTimeUpdate(playerInstance) {
      //Time updated handler

      /**
       * HandelAnalytics
       */
      this.$refs.analytics.setIntervalIfNeeded(playerInstance);
    },

    /**
     * Controls of player can also be controlled by admins and if admin did not allowed
     * to pause then we should not allow the player to pause. This function keeps player
     * playing if pause event is trigger by the users
     */
    pauseHandler(playerInstance){
      if(this.isPauseBlocked){
        playerInstance.play();
      }
    },

    /**
     *===========================================================================================
     *                               PLAYER CONFIGS CONTROLLER
     *===========================================================================================
     */

    handleHlsAvailableResolutions(payload) {
      let _this = this;
      this.player.controls.add({
        position: "right",
        html: this.customIcons.qualitySwitcher,
        selector: payload,
        onSelect: function (item, $dom) {
          EventBus.$emit("hls:switchVideoResolution", {
            height: item.height,
          });
          return _this.customIcons.qualitySwitcher;
        },
      });
    },

    /**
     *===========================================================================================
     *                               PLAYER CUSTOM CONTROLLERs
     *===========================================================================================
     */

    /** SUBTITLE HANDLERS  */
    addSubtitleControls(playerInstance) {
      let _this = this;

      //1. Do not add controls if subtitle is not available
      if (!this.availableSubtitles.length) {
        return;
      }

      //2. Enable Custom controls with switching option
      playerInstance.controls.add({
        position: "right",
        html: this.customIcons.subtitle,
        selector: this.availableSubtitles,
        onSelect: function (item, $dom) {
          _this.switchSubtitle(item.name, playerInstance);
          return _this.customIcons.subtitle;
        },
      });
    },

    switchSubtitle(nextSubtitleLanguage, playerInstance) {
      let subtitle = this.availableSubtitles.find(
        (subtitle) => subtitle.name == nextSubtitleLanguage
      );

      // Update Only if subtitle is available
      if (!subtitle) {
        return;
      }

      // 1. Switch in player
      playerInstance.subtitle.switch(subtitle.url, {
        default: true,
        html: subtitle.html,
      });
    },

    /**
     * Add quality switcher controls to player with its
     * default state
     */
    addCustomQualitySwitcher(playerInstance) {
      let _this = this;
      //1. Do not add controls if resolutions are not available
      if (!this.hlsAvailableResolutions.length) {
        return;
      }

      playerInstance.controls.add({
        position: "right",
        html: this.customIcons.qualitySwitcher,
        selector: this.hlsAvailableResolutions,
        onSelect: function (item, $dom) {
          _this.switchQuality(item.height);
          return _this.customIcons.qualitySwitcher;
        },
      });
    },

    /**
     * Switch quality and store it in state
     */
    switchQuality(newResolutionHeight) {
      let resolution = this.hlsAvailableResolutions.find(
        (resolution) => resolution.height == newResolutionHeight
      );

      //1. Update Only if resolution is available
      if (!resolution) {
        return;
      }

      EventBus.$emit("hls:switchVideoResolution", {
        height: resolution.height,
      });
    },
  },
};
</script>
<style scoped></style>
